import createReducer from "../../createReducer";
import { zapierTokensHandlers } from "../handlers";
import { IZapierTokensState } from "../types";

export const zapierTokens: IZapierTokensState = {
    isLoading: false,
    zapierToken: null,
};
export default createReducer(zapierTokens, zapierTokensHandlers);
